import * as React from 'react';
import * as Modal from 'react-modal';

import { Button, ButtonSize, ButtonTheme } from '@cian/button-component';
import { Preloader } from '@cian/components';
import { mergeStyles } from '@cian/utils/lib/shared/style';

import * as styles from './index.css';

import { TStatusFetch } from '../../../store/popups/reclaim';
import { IconClose } from '../assets/icon_close';

export interface IReclaimModalProps {
  errorMessage: string;
  isOpen: boolean;
  realtyOfferId: number;
  statusFetch: TStatusFetch;
}

export interface IReclaimModalDispatchProps {
  closeReclaimModal(): void;
  submitReclaimConfirm(host: string, realtyOfferId: number): void;
}

export type IProps = IReclaimModalProps & IReclaimModalDispatchProps;

const INTERVAR_FOR_CLOSE_MODAL = 5000;

export class ReclaimModal extends React.Component<IProps, {}> {
  private timerForCloseModal: number | undefined;

  public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
    if (nextProps.statusFetch === 'ok') {
      this.timerForCloseModal = window.setTimeout(() => this.props.closeReclaimModal(), INTERVAR_FOR_CLOSE_MODAL);
    }
  }

  public render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        contentLabel="Modal"
        onRequestClose={this.props.closeReclaimModal}
        style={{
          content: {
            overflow: 'visible',
            padding: '24px 30px 32px',
            position: 'static',
            width: '500px',
            zIndex: 101,
          },
          overlay: {
            alignItems: 'center',
            backgroundColor: 'rgba(24, 41, 48, .8)',
            display: 'flex',
            justifyContent: 'center',
            zIndex: 100,
          },
        }}
      >
        <div className={styles['head']}>
          <button className={styles['close']} onClick={this.handleCloseModal}>
            <IconClose />
          </button>
          {this.renderHeadMessage(this.props.statusFetch)}
        </div>
        <div
          {...mergeStyles([
            styles['error'],
            this.props.statusFetch === 'error' && styles['error--visible'],
            this.props.statusFetch === 'ok' && styles['error--hide'],
          ])}
        >
          {this.props.errorMessage}
        </div>
        {this.props.statusFetch !== 'ok' && (
          <div className={styles['body']}>
            <Button size={ButtonSize.S} onClick={this.handleConfirm}>
              {this.props.statusFetch === 'isLoad' ? (
                <div className={styles['preloader']}>
                  <Preloader size={16} />
                </div>
              ) : (
                'Подтвердить'
              )}
            </Button>
            <Button size={ButtonSize.S} theme={ButtonTheme.Ghost} onClick={this.handleCloseModal}>
              Отмена
            </Button>
          </div>
        )}
      </Modal>
    );
  }

  private handleCloseModal = () => {
    if (this.timerForCloseModal) {
      clearTimeout(this.timerForCloseModal);
    }

    this.props.closeReclaimModal();
  };

  private renderHeadMessage = (statusFetch: TStatusFetch) => {
    if (statusFetch === 'ok') {
      return (
        <div>
          Объявление будет переопубликовано
          <br />
          при следующем импорте
        </div>
      );
    }

    return (
      <div className={styles['title']}>
        Вы подтверждаете, что объявление
        <br />
        в базе исправлено в соответствии
        <br />с требованиями модератора?
      </div>
    );
  };

  private handleConfirm = () => {
    this.props.submitReclaimConfirm(window.location.host, this.props.realtyOfferId);
  };
}
